import { differenceInMinutes } from 'date-fns'

import { formatEtaWindow } from 'components/bookings/BookingDetails/MainBookingDetails/helpers'

export const BRISTOL_COORDINATES = { lat: 51.45, lng: -2.59 }
export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.toLocaleUpperCase().split('')
export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''

const formatMinutesToDuration = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (hours === 0) {
    return `${minutes}m`
  }

  return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
}

const formatDuration = (minutesX: number, minutesY: number): string => {
  if (minutesY <= 60) {
    return `${minutesX} - ${minutesY} min`
  }

  return `${formatMinutesToDuration(minutesX)} - ${formatMinutesToDuration(minutesY)}`
}

export const calculateDeliveryWindow = (nextAddressETA: string, etaWindowMinutes: number) => {
  const etaDate = new Date(nextAddressETA)

  const timeRange = formatEtaWindow(etaDate, etaWindowMinutes)

  const now = new Date()
  const minutesX = Math.max(0, differenceInMinutes(etaDate, now))
  const minutesY = minutesX + etaWindowMinutes

  const duration = formatDuration(minutesX, minutesY)

  return { timeRange, duration }
}
